import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MenuItemDirective } from './menu-item.directive';
import { FeatureFlag } from 'src/app/shared/models/enums/feature-flag';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
    selector: 'nova-nav-menu-link',
    standalone: true,
    imports: [NgClass, MatIconModule, MatListModule, MatButtonModule, MatBadgeModule, RouterModule],
    templateUrl: './nav-menu-link.component.html',
    styleUrls: ['./_styles.scss']
})
export class NavMenuLinkComponent {
    showHoverMenu: boolean;

    hoverMenuActive: boolean = false;

    hoveredModule: any;

    @Input()
    isActive = false;

    @Input()
    activeModuleItem: string;

    @Input()
    linkData: MenuItemDirective;

    @Input()
    isCollapsed: boolean;

    @Input() dealAlert: number;

    @Input()
    isOpen: boolean;

    @Output()
    moduleClick = new EventEmitter<string>();
    readonly featureFlag = FeatureFlag;

    onMouseOverModule(hover: boolean): void {
        if (hover) {
            this.showHoverMenu = hover;
        } else {
            setTimeout(() => {
                if (!this.hoverMenuActive) {
                    this.showHoverMenu = this.hoverMenuActive;
                }
            }, 100);
        }
    }

    keepActive(active: boolean): void {
        this.hoverMenuActive = active;
        this.onMouseOverModule(active);
    }

    handleModuleClick(): void {
        this.moduleClick.emit(this.linkData.name);
    }
}
